// Inspire from: https://github.com/xuopled/react-svg-piechart
import * as classnames from 'classnames/bind'
import * as React from 'react'
import { FC, MouseEvent, useState } from 'react'
import { isEmpty } from 'lodash'
import Circle from './circle'
import Sectors from './sectors'
import styles from './pie_chart.module.scss'

export type Data = {
  color: string
  expanded?: boolean
  title: string
  value: number
}

export type HoverSector = (e: MouseEvent<SVGPathElement | SVGEllipseElement>, d: Data, index?: number) => void

const cx = classnames.bind(styles)
const PieChart: FC<{
  className?: string
  data: Data[]
  expandOnHover?: boolean
  expandSize?: number
  startAngle?: number
  strokeColor?: string
  strokeWidth?: number
  viewBox?: number
  onSectorHover?: HoverSector
}> = ({
  className,
  data,
  expandOnHover = false,
  expandSize,
  startAngle,
  strokeColor,
  strokeWidth,
  viewBox = 100,
  onSectorHover
}) => {
  const [expandedIndex, setExpandedIndex] = useState(null)
  const center = viewBox / 2
  const offset = expandOnHover ? expandSize : 0
  const dataWithValue = data.filter(d => d.value > 0)

  if (isEmpty(dataWithValue)) {
    return null
  }

  const isSingleData = dataWithValue.length === 1
  const handleSectorHover = (e: MouseEvent<SVGPathElement>, data: Data, index: number) => {
    if (expandOnHover) {
      setExpandedIndex(index)
    }

    if (onSectorHover) {
      onSectorHover(e, data, index)
    }
  }

  return (
    <svg className={cx(className, styles.pieChart)} viewBox={`0 0 ${viewBox + offset * 2} ${viewBox + offset * 2}`}>
      <g transform={`translate(${offset}, ${offset})`}>
        {isSingleData ? (
          <Circle
            center={center}
            data={dataWithValue[0]}
            radius={dataWithValue[0].expanded || (expandOnHover && expandedIndex === 0) ? center + expandSize : center}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
            onSectorHover={handleSectorHover}
          />
        ) : (
          <Sectors
            center={center}
            data={
              expandOnHover
                ? dataWithValue.map((d, i) => ({
                    ...d,
                    expanded: i === expandedIndex
                  }))
                : dataWithValue
            }
            expandSize={expandSize}
            startAngle={startAngle}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
            onSectorHover={handleSectorHover}
          />
        )}
      </g>
    </svg>
  )
}

export default PieChart
